import { type RouteRecordRaw } from 'vue-router'

import { useGuestTypeStore } from '../guestTypes/guestType.store'
import { useProgramsStore } from '../programs/programs.store'
import { useScenesStore } from '../scenes/scenes.store'
import { useGuestsStore } from './store/guests.store'

export const GuestsRouter: RouteRecordRaw[] = [
  {
    path: '/guests',
    component: async () => import('./Guests.vue'),
    async beforeEnter(to, from) {
      if (!from.path.startsWith('/guests')) {
        useGuestsStore.getState().resetPagination()
      }
      await useGuestTypeStore.getState().list()
    },
  },
  {
    path: '/guests/create',
    component: async () => import('./AddingGuests.vue'),
    async beforeEnter() {
      await Promise.all([
        useGuestsStore.getState().getGuestsLinks(),
        useGuestTypeStore.getState().list(),
        useScenesStore.getState().list(),
        useProgramsStore.getState().list(),
      ])
    },
  },
  {
    path: '/guests/import',
    component: async () => import('./GuestImport.vue'),
    async beforeEnter() {
      useGuestsStore.getState().resetImport()
      await useGuestTypeStore.getState().list()
    },
  },
  {
    path: '/guests/:id',
    component: async () => import('./AddingGuests.vue'),
    async beforeEnter(to) {
      await Promise.all([
        useGuestsStore.getState().loadGuest(to.params.id as string),
        useGuestTypeStore.getState().list(),
        useScenesStore.getState().list(),
        useProgramsStore.getState().list(),
      ])
    },
  },
]
